import React from 'react';
import { Hero } from './components/Hero';
import { PainPoints } from './components/PainPoints';
import { Benefits } from './components/Benefits';
import { BonusSection } from './components/BonusSection';
import { Testimonials } from './components/Testimonials';
import { PricingCTA } from './components/PricingCTA';
import { Guarantee } from './components/Guarantee';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { SocialProofPopup } from './components/SocialProofPopup';
export function App() {
  return <div className="min-h-screen bg-brand-dark font-sans selection:bg-brand-rose selection:text-white overflow-x-hidden" data-id="element-0">
      <SocialProofPopup data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <PainPoints data-id="element-4" />
        <Benefits data-id="element-5" />
        <BonusSection data-id="element-6" />
        <Testimonials data-id="element-7" />
        <PricingCTA data-id="element-8" />
        <Guarantee data-id="element-9" />
        <FinalCTA data-id="element-10" />
      </main>
      <Footer data-id="element-11" />
    </div>;
}